import { render, staticRenderFns } from "./client-profile-master-unsubscribe-confirmation.vue?vue&type=template&id=355a260c"
import script from "./client-profile-master-unsubscribe-confirmation.vue?vue&type=script&lang=ts"
export * from "./client-profile-master-unsubscribe-confirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports